module.exports = __webpack_public_path__ + "static/img/14.4a35616.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/2/1/eng/14.png
// module id = +sf7
// module chunks = 0